import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { encrypt } from "../Utils/Encryption";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";

const PieCompare = ({ metricData }) => {
  const coordinates_data = JSON.parse(
    metricData?.comparison_coordinates || "{}"
  );

  const totalMetric1 = metricData?.value?.reduce(
    (sum, item) => sum + Number(item?.metric_1 || 0),
    0
  );
  const totalMetric2 = metricData?.value?.reduce(
    (sum, item) => sum + Number(item?.metric_2 || 0),
    0
  );

  const [chartData] = useState({
    series: [totalMetric1, totalMetric2],
    options: {
      chart: {
        type: "pie",
      },
      labels: [
        coordinates_data?.visualization_data?.datasets?.[0]?.label ||
          "Metric 1",
        coordinates_data?.visualization_data?.datasets?.[1]?.label ||
          "Metric 2",
      ],
      colors: ["#3a80c2", "#b1c74eff"],
      tooltip: {
        y: {
          formatter: (val) =>
            `${val} ${coordinates_data?.visualization_data?.value_type || ""}`,
        },
      },
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
      },
    },
  });

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && metricData?.pk_comparison_data_id ? (
          <Link
            to={`/dashboard/comparisonchildmetric/${
              metricData?.comparison_name
            }/${encrypt(metricData?.pk_comparison_data_id?.toString())}`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData?.comparison_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.comparison_name}</span>
          </div>
        )}
      </div>

      <div className="dashboardChart col-12 d-flex justify-content-center">
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="pie"
          height={350}
        />
      </div>
    </div>
  );
};

export default PieCompare;
